import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { UserProfileComponent, xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';
import { environment } from '../environments/environment';
import { ConfigManagerModule, xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataApiModule } from '@xpo-ltl/data-api';
import { LinealFeetComponent } from './linealFeet/linealFeet.component';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AppComponent, LinealFeetComponent],
  imports: [
    ConfigManagerModule,
    DataApiModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    XpoShellModule,
    XpoFooterModule,
    XpoCardModule,
    AppRoutingModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    UserProfileComponent
  ],
  providers: [
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration({
        firebaseOptions: environment.firebase,
        configFileUrl: '../assets/config.json',
      })
    ),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
